import { palette } from './tokens';

export type Mood = 'aurora' | 'midnight' | 'editorial';

export type ThemeColors = {
  name: Mood;
  bg: string;
  bgSoft: string;
  fg: string;
  fgSoft: string;
  fgMute: string;
  rule: string;
  accent: string;
  accentDeep: string;
  accentAlt: string;
  accentAltSoft: string;
  highlight: string;
  support: string;
  invert: string;
};

const sharedAurora = {
  bg: palette.paper,
  bgSoft: palette.paperSoft,
  fg: palette.ink,
  fgSoft: palette.inkSoft,
  fgMute: palette.inkMute,
  rule: 'rgba(21, 8, 46, 0.12)',
  accent: palette.wine,
  accentDeep: palette.wineDeep,
  accentAlt: palette.ember,
  accentAltSoft: palette.emberSoft,
  highlight: palette.gold,
  support: palette.verdeSlate,
  invert: palette.night,
};

export const auroraDay: ThemeColors = {
  name: 'aurora',
  ...sharedAurora,
};

export const midnightNeon: ThemeColors = {
  name: 'midnight',
  bg: palette.night,
  bgSoft: palette.nightSoft,
  fg: palette.nightInk,
  fgSoft: '#C8BFD8',
  fgMute: '#8A7FA0',
  rule: 'rgba(245, 240, 255, 0.14)',
  accent: palette.wine,
  accentDeep: palette.wineDeep,
  accentAlt: palette.ember,
  accentAltSoft: palette.emberSoft,
  highlight: palette.gold,
  support: palette.sandLilac,
  invert: palette.paper,
};

export const editorial: ThemeColors = {
  name: 'editorial',
  bg: '#e8e6e0',
  bgSoft: '#dcdad4',
  fg: '#1a1a1c',
  fgSoft: '#3d3a36',
  fgMute: '#6B665C',
  rule: 'rgba(26, 26, 28, 0.12)',
  accent: '#2b3a44',
  accentDeep: '#1a242b',
  accentAlt: '#a85a36',
  accentAltSoft: '#d4a48c',
  highlight: '#8a7848',
  support: palette.verdeSlate,
  invert: '#1a1a1c',
};

export const moods: Record<Mood, ThemeColors> = {
  aurora: auroraDay,
  midnight: midnightNeon,
  editorial,
};
